import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-add-popup',
  templateUrl: './add-popup.component.html',
  styleUrls: ['./add-popup.component.css']
})

export class AddPopupComponent implements OnInit {

  public region: string;
  public country: string;
  public name: String;
  public title;
  public reportingTeam: string;
  public reportingEntity: string;
  public fun: Function;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddPopupComponent>,
    ) {    }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title;
      this.fun = this.data.fun;
    } else {
    this.title = 'Undefine';
    }
  }

  cancel() {
    this.dialogRef.close('Cancel');
  }

  proceed() {
    this.dialogRef.close({'Name': this.name, 'Country': this.country, 'Region': this.region});
    this.fun();
  }

  newTeamAdd() {
    this.dialogRef.close({'Name': this.name, 'Country': this.country, 'Region': this.region});
  }

}
